import './SimpleFooter.less';
import React from 'react';
import __ from "../../../i18n";
import externalLinks from "../../../routing/externalLinks";
import config from '../../../../../../config.json';


export default function SimpleFooter({}) {

    return <div className="simple-footer">
        <p>
            {__('(GMT+07:00) Bangkok, Hanoi, Jakarta.')}
            <a
                className="text-link"
                title={__('Greenwich Mean Time +7')}
                href={externalLinks.greenwich_mean_time()}
                target="_blank"
            >{__('Learn more')}</a>
        </p>
        <p>
            {
                __('Copyright ::year ::site. All rights reserved.', {
                    site: config.metadata.name,
                    year: String(new Date().getFullYear())
                })
            }
        </p>
    </div>;
}
